import React from "react";

const AddInvestigation = React.createContext();

export default AddInvestigation;